function userInfo(state) {
  return state.user.info;
}

function seekerGuard(state) {
  return state.seekerGuard;
}

export { userInfo, seekerGuard };
